import { render, staticRenderFns } from "./taskdetail.vue?vue&type=template&id=d2bd8cf6"
import script from "./taskdetail.vue?vue&type=script&lang=js"
export * from "./taskdetail.vue?vue&type=script&lang=js"
import style0 from "./taskdetail.vue?vue&type=style&index=0&id=d2bd8cf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports